import React from "react";

import person from "../../assets/customer_name.svg";
import email from "../../assets/Email.svg";
import facebook from "../../assets/Facebook F.png";
import instagram from "../../assets/Instagram.png";
import location from "../../assets/location.svg";
import lock from "../../assets/password.svg";
import phone from "../../assets/Phone.png";
import calendar from "../../assets/upcoming_calendar.svg";
import website from "../../assets/Website.svg";

/**
 * Standard left icons for form fields (the web's own filled, dark icons), so every field looks the same:
 *   <TwInputGroup leftIcon={<FieldIcon name="email" />} … />
 * Names: person, club, lock, email, phone, location, website, calendar, instagram, facebook.
 * "club" (storefront) has no web asset, so it is drawn inline in the same filled style.
 */
const SRC = { person, email, facebook, instagram, location, lock, phone, calendar, website };

function ClubGlyph() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path fill="#212121" fillRule="evenodd" d="M5.1 2.5h13.8c.6 0 1.2.4 1.4 1l1.6 4.4c.4 1.2-.1 2.5-1.2 3.1-.9.5-2 .5-2.9 0a2.9 2.9 0 0 1-1.5-.9 2.9 2.9 0 0 1-4.3 0 2.9 2.9 0 0 1-4.3 0 2.9 2.9 0 0 1-1.5.9c-.9.5-2 .5-2.9 0-1.1-.6-1.6-1.9-1.2-3.1l1.6-4.4c.2-.6.8-1 1.4-1Z" />
      <path fill="#212121" fillRule="evenodd" d="M4.5 12.6c.9.3 1.9.3 2.8 0 .4-.1.8-.3 1.1-.6a4.4 4.4 0 0 0 3.6 1 4.4 4.4 0 0 0 3.6-1c.3.3.7.5 1.1.6.9.3 1.9.3 2.8 0V19a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 19v-6.4Zm5.5 8.9h4V17a1.5 1.5 0 0 0-1.5-1.5h-1A1.5 1.5 0 0 0 10 17v4.5Z" />
    </svg>
  );
}

export default function FieldIcon({ name }) {
  if (name === "club") return <ClubGlyph />;
  const src = SRC[name];
  if (!src) return null;
  return <img src={src} alt="" aria-hidden="true" className="h-5 w-5 object-contain" />;
}
